import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { store } from '@store/index';
import { AuthProvider } from '@auth/AuthProvider';
import { useAuth } from '@auth/AuthContext';
import { setApiCredentialsGetter } from '@api/baseApi';
import { ErrorBoundary } from '@components/ErrorBoundary';
import { router } from '@routes/index';

/**
 * Wires the auth credential getter into the API layer.
 * Must be rendered inside AuthProvider so useAuth() is available.
 */
function ApiCredentialsWirer({ children }: { children: React.ReactNode }) {
  const { getCredentials } = useAuth();

  useEffect(() => {
    setApiCredentialsGetter(getCredentials);
  }, [getCredentials]);

  return <>{children}</>;
}

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <ApiCredentialsWirer>
          <ErrorBoundary>
            <RouterProvider router={router} />
          </ErrorBoundary>
        </ApiCredentialsWirer>
      </AuthProvider>
    </Provider>
  );
}

export default App;
